// import 'lib/wdyr'
/* cant give chunkname or ie11 promise is not polyfilled? */
import "core-js/stable";
import "regenerator-runtime/runtime";

// mostly IE11 -- TODO dynamic import and wait to mount App 
//require("intersection-observer");

//require("@rails/ujs").start();

// import Turbolinks from "turbolinks";
// //require("react_ujs");

// Turbolinks.start();
// window.Turbolinks = Turbolinks;

// true pulls in all components even un-imported!
// false for nonrecursive lookup
// only put App.jsx in top-level components because this will pull in everything
// and doesnt support the 3rd argument regex
// var componentRequireContext = require.context("components", false);
// ReactRailsUJS.useContext(componentRequireContext);

// ReactRailsUJS.detectEvents();
// window.ReactRailsUJS = ReactRailsUJS;

// (Optional) Clean up global namespace maybe one day
// delete window.Turbolinks;
// delete window.ReactRailsUJS;

//import $ from "jquery";
// use rails-ujs only
//import {} from "jquery-ujs";

// element.remove() polyfill for IE
// trying to get away from jQuery
import "element-remove";

//import(
//  /* webpackChunkName: 'jqalrt' */ "@claviska/jquery-alertable/jquery.alertable"
//);

// currently needed on landing on song (video) page, artist pics page ?
// onload.js breaking sometimes when chunk isnt loaded yet
//import(
//  /* webpackChunkName: 'jq_magpop' */ "magnific-popup/dist/jquery.magnific-popup"
//);

    // $.ajaxSetup({
    //   cache: false,
    //   timeout: 60000,
    //   headers: {
    //     "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
    //   },
    // });

// $.cachedScript = function (url, options) {
//   options = $.extend(options || {}, {
//     dataType: "script",
//     cache: true,
//     url: url,
//   });

//   // Use $.ajax() since it is more flexible than $.getScript
//   // Return the jqXHR object so we can chain callbacks
//   return $.ajax(options);
// };

// band /_music_promotion video promo
// this already pulled in with react?
// what provides $().embed ?
// import "fomantic-ui/dist/components/embed";

// import { new_centered_window } from "lib/new_centered_window";
//import(/* webpackChunkName: 'hdlrtn' */ "lib/handle_retina");
// import "lib/listen_overlay";
// import(/* webpackChunkName: 'attach_auto' */ "lib/attach_autocomplete");

// import JangoGuest from "lib/guest";
// window._jangoGuest = new JangoGuest();

import Jango from "lib/jango";
window._jango = new Jango();

//import(/* webpackChunkName: 'vpp' */ "lib/video_player");
// import { VideoPlayer } from "lib/video_player";
// window._videoPlayer = new VideoPlayer();

import Onload from "lib/onload";
new Onload();

import "components/AppContainer";

import(/* webpackChunkName: 'appcss' */ "stylesheets/jango_application.scss");
